import { AddIcon } from "./icons";
import ProductPriceLabel from "./ProductPriceLabel";
import BestSellerBadge from "./BestSellerBadge";
import useQuickAdd from "../hooks/useQuickAdd";

export default function ProductsList(props) {
  const { products, onProductSelect = () => {} } = props;
  const { canQuickAdd, quickAdd } = useQuickAdd();

  if (!products) {
    return (
      <div className="empty-state">
        <p>Ops, nenhum produto encontrado...</p>
      </div>
    );
  }

  return (
    <ul className="menu-list">
      {products.map((product) => (
        <li key={product.id}>
          <MenuItem
            product={product}
            onSelect={() => onProductSelect(product.id)}
            onAdd={
              canQuickAdd(product)
                ? () => quickAdd(product)
                : () => onProductSelect(product.id)
            }
          />
        </li>
      ))}
    </ul>
  );
}

/**
 * Item do cardápio: texto à esquerda (nome e descrição em até 2 linhas cada,
 * preço), foto quadrada à direita com o "+" por cima.
 */
function MenuItem({ product, onSelect, onAdd }) {
  const handleKeyDown = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect();
    }
  };

  const handleAdd = (event) => {
    event.stopPropagation();
    onAdd();
  };

  const addButton = !product.disabled && (
    <button
      type="button"
      className="add-button"
      onClick={handleAdd}
      aria-label={`Adicionar ${product.name}`}
    >
      <AddIcon />
    </button>
  );

  return (
    <div
      className={`menu-item${product.pictureUrl ? " has-media" : ""}${
        product.disabled ? " is-disabled" : ""
      }`}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={handleKeyDown}
    >
      <div className="menu-item__body">
        <ProductName product={product} />
        <ProductBadges product={product} />
        <ProductDetails product={product} />
        <div className="menu-item__footer">
          <ProductPrice product={product} />
          {!product.pictureUrl && addButton}
        </div>
      </div>
      {product.pictureUrl && (
        <div className="menu-item__media">
          <img
            loading="lazy"
            decoding="async"
            src={product.pictureUrl}
            alt=""
            width="104"
            height="104"
            className="menu-item__img"
          />
          {product.isBestSeller && <BestSellerBadge overlay />}
          {addButton}
        </div>
      )}
    </div>
  );
}

export function ProductName({ product }) {
  return <h3 className="menu-item__name">{product.name}</h3>;
}

export function ProductBadges({ product }) {
  // Com foto, o selo de mais pedido vai sobre a imagem, não aqui.
  const bestSellerInline = product.isBestSeller && !product.pictureUrl;
  if (!product.disabled && !bestSellerInline) {
    return null;
  }

  return (
    <div className="menu-item__badges">
      {bestSellerInline && <BestSellerBadge />}
      {product.disabled && <span className="tag tag--muted">Indisponível</span>}
    </div>
  );
}

export function ProductDetails({ product }) {
  if (!product.details) {
    return null;
  }

  return <p className="menu-item__details">{product.details}</p>;
}

export function ProductPrice({ product }) {
  return (
    <p className="menu-item__price">
      <ProductPriceLabel product={product} />
    </p>
  );
}
